module.exports = __webpack_public_path__ + "static/media/iphonex.2bf92c3e.png";